"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormGroup = _interopRequireDefault(require("./FormGroup"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormInputModule = _interopRequireDefault(require("./FormInput.module.scss"));

var _Beep = _interopRequireDefault(require("../utils/Beep"));

var _excluded = ["errors", "fieldsError", "type", "name", "label", "value", "innerRef", "onBlur", "onKeyPress", "onKeyUp", "onChange", "skip", "fieldType", "id", "suggestions", "hintLabel", "additionalContentBelow", "formik", "blacklist", "autoFill", "autoFormat", "max", "turnOffAutoFill"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var INPUT_TYPES = ["text", "password", "email", "number", "tel", "url", "search", "range", "color", "date", "time", "datetime", "datetime-local", "month", "week", "file"];

function FormInput(props) {
  var _classNames;

  var errors = props.errors,
      fieldsError = props.fieldsError,
      type = props.type,
      name = props.name,
      label = props.label,
      value = props.value,
      innerRef = props.innerRef,
      onBlur = props.onBlur,
      onKeyPress = props.onKeyPress,
      onKeyUp = props.onKeyUp,
      onChange = props.onChange,
      skip = props.skip,
      fieldType = props.fieldType,
      id = props.id,
      suggestions = props.suggestions,
      hintLabel = props.hintLabel,
      additionalContentBelow = props.additionalContentBelow,
      formik = props.formik,
      blacklist = props.blacklist,
      autoFill = props.autoFill,
      autoFormat = props.autoFormat,
      max = props.max,
      turnOffAutoFill = props.turnOffAutoFill,
      attrs = _objectWithoutProperties(props, _excluded);

  if (skip) {
    return null;
  }

  if (formik) {
    value = formik.values[name];

    if (!onChange) {
      onChange = function onChange(e) {
        if (e.target.value) {
          if (autoFill && e.target.value === '~') {
            if (typeof autoFill === "function") {
              e.target.value = autoFill();
            } else {
              e.target.value = autoFill;
            }
          }

          if (blacklist) {
            e.target.value = e.target.value.replace(blacklist, "");
          }

          if (autoFormat && typeof autoFormat === "function") {
            e.target.value = autoFormat(e.target.value);
          }

          if (max && e.target.value.length > max) {
            (0, _Beep["default"])();
            return;
          }
        }

        formik.handleChange(e);
      };
    }

    if (!onBlur) {
      onBlur = formik.handleBlur;
    }

    if (!errors) {
      errors = formik.touched[name] && formik.errors;
    }
  }

  var errorMessage = null;

  if (errors) {
    errorMessage = errors[name];
  }

  var fieldError = null;

  if (fieldsError) {
    fieldError = fieldsError[name];
  }

  var suggestion = null;

  if (suggestions) {
    suggestion = suggestions[name];
  }

  var inputClasses = (0, _classnames["default"])((_classNames = {
    "form-control": true
  }, _defineProperty(_classNames, _FormInputModule["default"].enabled, true), _defineProperty(_classNames, _FormInputModule["default"].invalidDisabled, true), _classNames));

  if (!turnOffAutoFill) {
    turnOffAutoFill = false;
  }

  return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    hasError: !!errorMessage,
    filled: !!value
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "bmd-label-floating",
    htmlFor: name,
    id: name + 'Label'
  }, errorMessage || label), /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: type
  }, attrs, {
    className: inputClasses,
    id: name,
    name: name,
    value: value || "",
    "data-testid": "form-input",
    ref: innerRef,
    onBlur: onBlur,
    onKeyPress: onKeyPress,
    onKeyUp: onKeyUp,
    onChange: onChange,
    onFocus: function onFocus(event) {
      if (turnOffAutoFill) {
        event.target.setAttribute('autocomplete', 'turnOffAutoFill');
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: _FormInputModule["default"].fieldError
  }, fieldError), /*#__PURE__*/_react["default"].createElement("span", {
    className: _FormInputModule["default"].fieldSuggestion
  }, suggestion), hintLabel && /*#__PURE__*/_react["default"].createElement("p", {
    className: _FormInputModule["default"].hintLabel
  }, hintLabel), additionalContentBelow && additionalContentBelow());
}

FormInput.propTypes = {
  type: _propTypes["default"].oneOf(INPUT_TYPES),
  fieldType: _propTypes["default"].oneOf(INPUT_TYPES),
  value: _propTypes["default"].any,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  innerRef: _propTypes["default"].object,
  onBlur: _propTypes["default"].func,
  onKeyPress: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  errors: _propTypes["default"].object,
  fieldsError: _propTypes["default"].object,
  skip: _propTypes["default"].bool
};
FormInput.defaultProps = {
  type: "text"
};
var _default = FormInput;
exports["default"] = _default;